import React from 'react';

import {ReactComponent as DownloadIcon} from 'shared/assets/download.svg';
import {downloadSignatureById} from 'shared/utils/file';

import 'components/ais/reclaiming-information-card/fields/signature-item/signature-item.less';

interface ISignatureItemProps {
    signatureName: string | undefined;
    attachmentId: string | undefined;
    entityName: string;
    isDownloadDisabled?: boolean;
}

export const SignatureItem = ({
    signatureName, attachmentId, entityName, isDownloadDisabled,
}: ISignatureItemProps) => (
    <div
        className="signature-item"
    >
        <div className="signature-item-info">
            {signatureName ?? '-'}
            {!!signatureName && !isDownloadDisabled && (
                <DownloadIcon
                    onClick={() => attachmentId && downloadSignatureById(
                        signatureName,
                        attachmentId,
                        entityName,
                    )}
                />
            )}
        </div>
    </div>
);
